// extracted by mini-css-extract-plugin
export default {"btn":"button_btn__HeAxz","lightOrange":"button_lightOrange__UQWRu"};